import * as React from "react";
const SvgIcMenuArrowDown = props => <svg viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.667.667 4 4 7.333.667H.667Z" /></svg>;
export default SvgIcMenuArrowDown;